import * as angular from "angular";

angular
  .module('bringoz.admin.billing-accounts')
  .constant('ConsolidatedBillingOrders_PN', {
    database: 'consolidatedBillingOrder'
  });
